import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  OPEN_TC_AGREE_MODAL,
  CLOSE_TC_AGREE_MODAL,
  API_ERROR,
  CHECK_COOKIE_AGREE_SUCCESS,
  UPDATE_COOKIE_AGREE_SUCCESS,
  SET_LOGIN_LOADING,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  tcAgreeModal: false,
  agreeCookie: true,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case OPEN_TC_AGREE_MODAL:
      state = { ...state,
        loading: false,
        tcAgreeModal: true,
      }
      break
    case CLOSE_TC_AGREE_MODAL:
      state = { ...state,
        tcAgreeModal: false,
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case CHECK_COOKIE_AGREE_SUCCESS:
      state = {
        ...state,
        agreeCookie: action.payload,
      }
      break
    case UPDATE_COOKIE_AGREE_SUCCESS:
      state = {
        ...state,
        agreeCookie: action.payload,
      }
      break
    case SET_LOGIN_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
